<template>
  <div id="app">
     <component :is="currentComponent" v-if="currentComponent" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentComponent: null
    }
  },
  async mounted() {
    const urlParts = window.location.href.split('/');
    const componentName = urlParts[3] || 'project1-1'; // 默认组件

    try {
      // 使用动态 import 加载组件
      const module = await import(`./components/${componentName}.vue`);
      this.currentComponent = module.default;
    } catch (error) {
      console.error('Failed to load component:', componentName, error);
    }
  }
}
</script>

<style>
body{
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: rgb(247, 247, 247);
}
</style>
